import type { UnionTypeLibelle } from '../../../techniques'

export const TailleEntreprise = ['PE', 'ME', 'GE'] as const
export type TailleEntreprise = (typeof TailleEntreprise)[number]

export const TailleEntrepriseLibelle: UnionTypeLibelle<TailleEntreprise> = {
  PE: 'Petite entreprise',
  ME: 'Moyenne entreprise',
  GE: 'Grande entreprise',
} as const
